<template>
  <div>
    <vs-popup classContent="popup-example" title="Confirm Customer Details" :active.sync="sendInvoiceSuccess"
      id="addSupplierPOP">
      <div class="modal-body">
        <div class="row">
          <div style="text-align:center">
            <img src="../../assets/icons/checkcirclePOP.png" alt="login" class="mx-auto"
              style="height:70%;padding-top:15px" />
          </div>
          <div>
            <div style="margin-top: 20px;">
              Agreement link sent <br />
              <span style="color:#97C93E">Successfully!</span>
            </div>
          </div>
          <div style="white-space: nowrap;text-align: right;margin-right: 5px;"
            @click="sendInvoiceSuccess = !sendInvoiceSuccess">
            <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null"
              style="color: black;">close</i>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Confirm Customer Details" :active.sync="sendInvoiceFailure"
      id="addSupplierPOP">
      <div class="modal-body">
        <div class="row">
          <div style="text-align:center">
            <img src="../../assets/icons/info.png" alt="login" class="mx-auto" style="height:70%;padding-top:15px" />
          </div>
          <div>
            <div style="margin-top: 20px;">
              Send agreement link fail ! <br />{{ errorMessage }}
            </div>
          </div>
          <div style="white-space: nowrap;text-align: right;margin-right: 5px;"
            @click="sendInvoiceFailure = !sendInvoiceFailure">
            <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null"
              style="color: black;">close</i>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Are You Sure You Want To Send SMS?" :active.sync="showPassportFontPop"
      id="addSupplierPOP">
      <div class="modal-body">
        <div class="row" style="float: right;margin-right: 0px;" @click="showPassportFontPop = !showPassportFontPop">
          <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null"
            style="background: rgb(0, 0, 0);color: white;">close</i>
        </div>
        <embed :src="viewPassportImage" width="600" height="600" type="application/pdf" />

        <!-- <v-img
          max-width="600"
          :src="viewPassportImage"
          style="margin:10px;"
        ></v-img> -->
      </div>
    </vs-popup>
    <vx-card class="card" style="height: fit-content;margin-top : 28px;width:100%;">
      <div style="display: flex;">
        <div class="col-6">
          <span style="width:50%;font-size: 18px; color: #5e5873; font-weight: 500">
            <b>Agreement Form</b>
          </span>
        </div>
        <div class="col-6" style="text-align:right">
          <b-button v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-primary" @click="customerProfile()"
            v-b-modal.modal-center style="margin-left: 20px;padding: 5px 28px;" v-show="sendLinkButtonSHow">
            <feather-icon icon="SendIcon" style="width:16px" class="mr-50" />
            <span class="align-middle" style="vertical-align: super !important;">Send Agreement Form</span>
          </b-button>
        </div>
      </div>
      <hr class="hr5" style="margin-left: -1.5rem;
    margin-right: -1.5rem;" />
      <div style="margin: auto;padding:11px 34px;display: flex;">
        <div style="display: flex;">
          <embed :src="agreementUrl" width="146" height="201" type="application/pdf" v-show="agreementUrl.length > 0" />
          <img v-show="agreementUrl.length == 0" src="../../assets/icons/noagreement.png" />
          <div style="font-size:14px;margin-left: 10px;color:#5E5873">
            <b v-show="agreementUrl.length > 0">Agreement PDF</b>
            <br /><feather-icon v-show="agreementUrl.length > 0" icon="EyeIcon"
              style="height: 15px;width: 15px;color:#4328AE;cursor:pointer;"
              @click="viewPassportFront(agreementUrl)" /><feather-icon v-show="agreementUrl.length > 0"
              icon="DownloadIcon" style="height: 15px;width: 15px;margin-left: 10px;color:#4328AE;cursor:pointer;"
              @click="downloadPassFront(agreementUrl)" />
            <br v-show="agreementUrl.length > 0" />
            <span style="font-size:12px;color:#B9B9C3">Agreement Signed</span>
            <div v-if="agreementUrl.length == 0">
              <feather-icon icon="XCircleIcon"
                style=";margin-right:10px;height: 15px;width: 15px;color:#EA5455;cursor:pointer;" />
              <span style="font-size:12px;color:#EA5455;vertical-align: top;">No</span>
            </div>
            <div v-else>
              <feather-icon icon="CheckCircleIcon"
                style=";margin-right:10px;height: 15px;width: 15px;color:#97C93E;cursor:pointer;" />
              <span style="font-size:12px;color:#97C93E;vertical-align: top;">Yes</span>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="card" style="height: fit-content;margin-top : 28px;width:100%;">
      <div style="display: flex;">
        <div class="col-6">
          <span style="width:50%;font-size: 18px; color: #5e5873; font-weight: 500">
            <b>Mandatory Checks</b>
          </span>
        </div>
      </div>
      <hr class="hr5" style="margin-left: -1.5rem;
    margin-right: -1.5rem;" />

      <b-table striped responsive="sm" :fields="fields" :items="checkList">
        <template #cell(checks)="data">
          <a style="color:#6E6B7B"><b>{{ data.value }}</b></a>
        </template>
        <template #cell(isMandatory)="data">
          <b-badge style="cursor:pointer;margin-right: 10px;margin-top: 4px;
    margin-left: 10px;" :style="{
      color: data.value == 'Yes' ? '#97C93E' : '#EA5455',
      background: data.value == 'Yes' ? '#EEF4E4' : '#F8E6E7'
    }" v-if="
              data.item.checks != 'CPV Done / Uploaded' &&
              data.item.checks != 'URC Uploaded'
            ">
            {{ data.value }}
          </b-badge>
          <v-select v-model="data.item.isMandatory" :options="items" v-on:input="checkSelectes()"
            placeholder="Select Supplier" style="font-size:12px;width:150px" v-else>
            <template slot="option" slot-scope="option">
              <b-badge style="cursor:pointer;margin-right: 10px;margin-top: 4px;
    margin-left: 10px;" :style="{
      color: option.label == 'Yes' ? '#97C93E' : '#EA5455',
      background: option.label == 'Yes' ? '#EEF4E4' : '#F8E6E7'
    }">
                {{ option.label }}
              </b-badge>
            </template>
            <template slot="selected-option" slot-scope="option">
              <b-badge style="cursor:pointer;margin-right: 10px;margin-top: 4px;
    margin-left: 10px;" :style="{
      color: option.label == 'Yes' ? '#97C93E' : '#EA5455',
      background: option.label == 'Yes' ? '#EEF4E4' : '#F8E6E7'
    }">
                {{ option.label }}
              </b-badge>
            </template>
          </v-select>
          <!-- <v-menu ref="menu" v-else>
            <template v-slot:activator="{ on, attrs }">
              <div
                style="padding: 0px 5px;
    width: fit-content;
    border: 0.5px solid;
    border-radius: 5px;
    cursor:pointer;"
                v-bind="attrs"
                v-on="on"
                :id="data.item.checks"
              >
                <b-badge
                  data-app
                  style="margin-right: 10px;margin-top: 4px;
    margin-left: 5px;"
                  :style="{
                    color: data.value == 'Yes' ? '#97C93E' : '#EA5455',
                    background: data.value == 'Yes' ? '#EEF4E4' : '#F8E6E7',
                  }"
                >
                  {{ data.value }}
                </b-badge>
                <feather-icon
                  icon="ChevronDownIcon"
                  style="width: 15px; height:
          15px;color:#B9B9C3;"
                />
              </div>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in items" :key="index">
                <v-list-item-title @click="closeMenu(data.item.checks)"
                  ><b-badge
                    style="cursor:pointer;margin-right: 10px;margin-top: 4px;
    margin-left: 10px;"
                    :style="{
                      color: item.title == 'Yes' ? '#97C93E' : '#EA5455',
                      background: item.title == 'Yes' ? '#EEF4E4' : '#F8E6E7',
                    }"
                  >
                    {{ item.title }}
                  </b-badge></v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu> -->
        </template>
        <template #cell(status)="data">
          <feather-icon icon="CheckCircleIcon" style="width: 25px; height:
          25px;color:#97C93E" v-if="data.value == 'PASS'" />

          <feather-icon icon="XCircleIcon" style="width: 25px;
    height: 25px;color:#EA5455" v-else />
        </template>
        <template #cell(startDate)="data">
          {{ data.value | moment("DD MMM YYYY") }}
        </template>
      </b-table>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
import { BRow, BCol, BFormRadio, BCard, BCardText } from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  data() {
    return {
      viewPassportImage: "",
      showPassportFontPop: false,
      items: ["Yes", "No"],
      supplierDetails: {},
      sendLinkButtonSHow: true,
      checkList: [
        { checks: "KYC Approved", isMandatory: "Yes", status: "PASS" },
        { checks: "Credit Approved", isMandatory: "Yes", status: "FAILED" },

        {
          checks: "Loan Agreement Signed",
          isMandatory: "Yes",
          status: "FAILED"
        },
        {
          checks: "Mandate Active/ Cheque Taken",
          isMandatory: "Yes",
          status: "FAILED"
        },
        { checks: "CPV Done / Uploaded", isMandatory: "Yes", status: "FAILED" },
        { checks: "URC Uploaded", isMandatory: "Yes", status: "FAILED" }
      ],
      finacePlaList: [],
      program: "",
      agreement: "",
      agreementUrl: "",
      errorMessage: "",
      sendInvoiceFailure: false,
      sendInvoiceSuccess: false,
      fields: [
        {
          key: "checks",
          label: "CHECKS"
        },
        {
          key: "isMandatory",
          label: "IS MANDATORY"
        },
        {
          key: "status",
          label: "STATUS"
        }
      ]
    };
  },
  components: {
    BRow,
    BCol,
    BFormRadio,
    BCardText,
    BCard,

    vSelect
  },
  created() {
    this.$store.commit("routeChange", "end");
    this.fetchApplicationId();

    this.getChecks();
    this.kycDocuments();
  },
  methods: {
    checkSelectes() {
      this.$store.commit("routeChange", "start");
      let self = this;

      let url =
        "https://uatgateway.supermoney.in/supermoney-service/check/operations/update/flag";
      let request = {
        customerId: self.$route.query.data,
        applicationId: self.$route.query.applicationId,
        checkCPVStatus: self.checkList[4].isMandatory == "Yes" ? true : false,
        checkURCStatus: self.checkList[5].isMandatory == "Yes" ? true : false,
        loggedInUser: this.$store.getters.loginId
      };

      axios
        .put(url, request, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    },
    kycDocuments() {
      console.log("this is third tab");

      this.$store.commit("routeChange", "start");
      var timestamp = Math.round(+new Date() / 1000);

      var data = {
        customerID: this.$route.query.data
      };
      var msgHeader = {
        authToken: localStorage.getItem("authtoken"), //dynamic
        authLoginID: this.$store.getters.loginId,
        timestamp: timestamp,
        ipAddress: ""
      };
      var employeeKycDetails = { data, msgHeader };
      axios
        .post("mlCustomerDetails", employeeKycDetails)
        .then(response => {
          const JSONData = response.data;
          if (JSONData.data.error == 0) {
            this.dataAvailable = true;
            // this.getKycVerificationID();

            this.mobileNumber = JSONData.data.custCredentials.loginID;
            //this.getbankDetails();
            this.securityCheckArray = JSONData.data.custKycDocuments.filter(
              function (item) {
                return item.documentTypeID == 115;
              }
            );
            console.log("==" + JSON.stringify(this.securityCheckArray));
            // if (this.securityCheckArray.length > 0) {
            //   this.chequeUrl =
            //     "https://uatgateway.supermoney.in/python/" +
            //     "mlS3Read?customerID=" +
            //     this.$route.query.data +
            //     "&docSeqID=" +
            //     this.securityCheckArray[0].docSeqID;
            //   console.log("==" + this.chequeUrl);
            // }

            this.$store.commit("routeChange", "end");
          } else {
            this.errorMessage = JSONData.data.message;
            this.GeneralError = true;
            this.dataAvailable = false;
          }
          this.$store.commit("routeChange", "end");
        })
        .catch(error => {
          this.errorText = error;
          this.dataAvailable = false;
          console.log("display Error" + this.errorText);
          this.$store.commit("routeChange", "end");
        });
    },
    customerProfile() {
      this.$store.commit("routeChange", "start");
      let self = this;

      let url =
        "https://uatgateway.supermoney.in/mintLoan/mintloan/customerProfile";
      let request = {
        loginId: self.mobileNumber,
        applicationId: self.$route.query.applicationId
      };

      axios
        .post(url, request, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          const JSONData = response.data;
          if (JSONData.errorMessage === "") {
            self.sendMandateLink(JSONData.name);
          } else {
            self.alert = true;
            self.alertMessage = JSONData.errorMessage;
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    },
    sendMandateLink(name) {
      let self = this;

      self.$store.commit("routeChange", "start");

      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",

        headers: { "content-type": "application/json" }
      });

      let data = {
        customerId: self.$route.query.data,
        applicationId: self.$route.query.applicationId,
        customerName: name,
        mobileNumber: self.mobileNumber
      };
      instance
        .post("sendExecutingAgreement", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          if (JSONData.successFlag) {
            self.sendInvoiceSuccess = true;
          } else {
            self.errorMessage = JSONData.kaleyraError;
            self.sendInvoiceFailure = true;
          }
          self.$store.commit("routeChange", "end");
        })
        .catch(error => {
          self.$store.commit("routeChange", "end");

          if (error) {
            console.log("display  ==" + error);
          }
        });
    },
    downloadPassFront(urlSet) {
      const axiosWithoutAuth = axios.create({
        baseURL: "https://uatgateway.supermoney.in/python/" // Set the baseURL for these requests
      });

      axiosWithoutAuth.defaults.headers = {
        "content-type": "application/x-www-form-urlencoded"
      };
      var documentUrl = urlSet;
      let config = {
        // example url
        url: urlSet,
        method: "GET",
        responseType: "blob"
      };
      axiosWithoutAuth(config).then(response => {
        let routeData = response.config.url;

        axiosWithoutAuth({
          url: routeData,
          method: "GET",
          responseType: "blob"
        }).then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "file.pdf");
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$store.commit("routeChange", "end");
        });

        //this.src = response.config.url;
      });
    },

    viewPassportFront(url) {
      this.viewPassportImage = url;
      this.showPassportFontPop = true;
    },
    closeMenu(ref) {
      console.log(ref);
      this.$refs.menu.isActive = false;
    },
    fetchApplicationId() {
      this.$store.commit("routeChange", "start");
      let self = this;

      let url =
        "https://uatgateway.supermoney.in/supermoney-service/customer/application/get";
      let request = {
        customerId: self.$route.query.data,
        applicationId: self.$route.query.applicationId
      };

      axios
        .post(url, request, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          console.log(response);
          const JSONData = response.data;
          self.program =
            JSONData.getCustomerApplicationResponseList[0].programDetails;
          self.agreement =
            JSONData.getCustomerApplicationResponseList[0].customerAgreementApplicationResp;
          if (self.agreement != null) {
            self.sendLinkButtonSHow = false;
            self.agreementUrl =
              "https://uatgateway.supermoney.in/python/" +
              "mlS3Read?customerID=" +
              self.$route.query.data +
              "&docSeqID=" +
              self.agreement.agreementDocSeqId;
          } else {
            self.sendLinkButtonSHow = true;
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    },
    getChecks() {
      this.$store.commit("routeChange", "start");
      let self = this;

      let url =
        "https://uatgateway.supermoney.in/supermoney-service/check/operations/get";
      let request = {
        customerId: self.$route.query.data,
        applicationId: self.$route.query.applicationId
      };

      axios
        .post(url, request, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          console.log(response);
          const JSONData = response.data;
          self.checkList[0].status = JSONData.kycStatus;
          self.checkList[1].status = JSONData.creditApprovedStatus;
          self.checkList[2].status = JSONData.loanAgreementSignedStatus;
          self.checkList[3].status = JSONData.mandateOrChequeTakenStatus;
          self.checkList[4].status = JSONData.cpvStatus;
          self.checkList[5].status = JSONData.urcStatus;
          self.checkList[4].isMandatory = JSONData.checkCPVStatus
            ? "Yes"
            : "No";
          self.checkList[5].isMandatory = JSONData.checkURCStatus
            ? "Yes"
            : "No";
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    }
  },
  computed: {},
  watch: {}
};
</script>
<style lang="scss">
#financing-plan>div {
  border: 0px solid rgba(60, 60, 60, 0.26);
}

#financing-plan>div>div>input {
  font-size: 12px;
}

div.isDefault>.custom-control-label::after {
  left: 0px !important;
}

div.isDefault>.custom-control-label::before {
  left: 0px !important;
}

#modal-archive-program___BV_modal_header_ {
  display: none;
}

tr {
  text-align: start !important;
}

td {
  text-align: start !important;
}

.hr5 {
  border: 0;
  border-top: 1px solid #ebe9f1;
}

.badge {
  vertical-align: top;
}

.v-menu__content {
  position: fixed !important;
}

.v-select .vs__dropdown-toggle .vs__actions .vs__clear {
  display: none;
}

.vs__selected {
  background-color: #7367f0;
  border: 0 solid rgba(60, 60, 60, 0.26);
  border-radius: 0.357rem;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
}

.v-select:not(.vs--single) .vs__selected>button>span>svg {
  color: #fff;
  stroke: #fff;
  opacity: 1;
}

.v-select:not(.vs--single) .vs__selected {
  color: #fff;
}

.v-select:not(.vs--single) .vs__selected {
  margin: 5px 2px 2px 5px;
}

.v-select:not(.vs--single) .vs__selected {
  border-radius: 3px;
  padding: 0 0.6em;
}

.vs__selected-options {
  clear: both;
  display: inline-block;
  overflow: auto;
  white-space: nowrap;
}

.vs__selected-options::-webkit-scrollbar {
  display: none;
}

.vs__selected {
  display: inline-flex;
}

.vs__dropdown-option--selected.vs__dropdown-option--highlight {
  color: #fff !important;
  background-color: #7367f0 !important;
}

.vs__dropdown-option--selected {
  background-color: #7367f0 !important;
  color: #fff !important;
  position: relative;
}

.vs__dropdown-option--highlight {
  color: #7367f0;
  background: rgba(115, 103, 240, 0.12);
}

.vs__dropdown-option {
  padding: 7px 20px;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.vs__dropdown-option--selected::after {
  content: "";
  height: 1.1rem;
  width: 1.1rem;
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 1.1rem;
}

.vs__search {
  width: auto;
}
</style>
